import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export interface SuccessButtonProps extends Omit<TouchableProps, 'haptic'> {
  size?: 'md' | 'lg';
}

const BASE_MD =
  'w-full py-3 rounded-2xl bg-success-strong text-white font-bold active:scale-[0.98] transition-all';

const BASE_LG =
  'h-20 bg-success-strong text-white rounded-3xl font-extrabold text-lg active:scale-[0.97] transition-all';

export const SuccessButton: React.FC<SuccessButtonProps> = ({
  size = 'md',
  className,
  ...rest
}) => {
  const base = size === 'lg' ? BASE_LG : BASE_MD;
  return (
    <Touchable haptic="success" className={className ? `${base} ${className}` : base} {...rest} />
  );
};
